import { render, staticRenderFns } from "./briefly.vue?vue&type=template&id=55a0a2e4&scoped=true"
import script from "./briefly.vue?vue&type=script&lang=js"
export * from "./briefly.vue?vue&type=script&lang=js"
import style0 from "./briefly.vue?vue&type=style&index=0&id=55a0a2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0a2e4",
  null
  
)

export default component.exports